import { floatFormatter, integerFormatter } from '@utils/common/formatter';
import moment from 'moment';

export class BaseChart {
  setBasicHighChartOption() {
    return {
      title: {
        text: '',
      },
      exporting: {
        enabled: false,
      },
      series: [],
      xAxis: {
        type: 'category',
        tickmarkPlacement: 'on',
        title: { text: '' },
        labels: {
          overflow: 'justify',
          style: {
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '11px',
          },
          formatter: function () {
            if (moment(this.value, 'YYYY-MM-DD', true).isValid()) {
              return moment(this.value, 'YYYY-MM-DD').format('MM/DD');
            } else {
              return this.value;
            }
          },
        },
      },
      yAxis: {
        title: { text: '' },
        labels: {
          overflow: 'justify',
          style: {
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '11px',
          },
          formatter() {
            return this.value;
          },
        },
      },
      plotOptions: {
        series: {
          cursor: 'pointer',
          dataLabels: {
            style: { lineHeight: '10px', fontSize: '8px', textShadow: 'none' },
          },
        },
        dataLabels: {
          style: { fontSize: '8px' },
        },
      },
      legend: {
        itemStyle: {
          fontWeight: 'bold',
          fontSize: '12px',
        },
      },
      credits: { enabled: false },
    };
  }

  pieChartTooltipOption() {
    return {
      shared: true,
      useHTML: true,
      formatter: function () {
        const point = this.point ? this.point : this.points[0].point;
        return `<span>${point.name}</span> <b><span style='color:${point.color}'>
        <b>${Math.round(this.percentage)}%</b> (${point.y})</span></b>`;
      },
      align: 'center',
      style: {
        fontSize: '12px',
        fontFamily: 'notoSans',
        fontWeight: '400',
      },
    };
  }

  pieStarRatingTooltipOption() {
    return {
      shared: true,
      useHTML: true,
      formatter: function () {
        var point = this.point;
        var formatStr = '<strong>Rating</strong> ';

        for (let index = 0; index < parseInt(point.name); index++) {
          formatStr += '<p class="btn-ico-single star-active"></p>';
        }
        formatStr += `
        <br /><span style="color:${point.color}">●</span> <b>${floatFormatter(
          point.percentage,
          2
        )}%</b> (<strong>${integerFormatter(point.y)}</strong>)
        `;
        return formatStr;
      },
    };
  }

  // // TODO: legend 값 default (추후 디자인 맞게 수정처리할것) - 사용: APP-Review-Reviews
  // legendDefaultOption() {
  //   return {
  //     align: 'center',
  //     alignColumns: true,
  //     backgroundColor: undefined,
  //     borderColor: '#999999',
  //     borderRadius: 0,
  //     borderWidth: 0,
  //     className: 'highcharts-no-tooltip',
  //     enabled: undefined,
  //     floating: false,
  //     itemCheckboxStyle: {"width": "13px", "height": "13px", "position":"absolute"},
  //     itemDistance: 20,

  //   };
  // }
}
